import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/SG.png";

export const stompingGroundsDetail = {
  "stomping-grounds": {
    id: "stomping-grounds",
    title: "Stomping Grounds",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "stomping-grounds",
        items: [
          {
            id: "stomping-grounds-1",
            title: "Stomping Grounds",
            description: "Kick Ass and Take Names 2019",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
